import compact from 'lodash-es/compact';
import { getUserCourseAccess } from '@yi/core';
import { MembershipTier } from '@yi/core/src/gql/generated/typesClient';

import { useAccessTier } from '~/src/common/subscription/useAccessTier';

import { useUserWithPurchasedCoursesByIds } from './useUserWithPurchasedCoursesByIds';

export const useUserHasAccessToCourse = (
  course: {
    id: string;
    permissions: (MembershipTier | null)[];
  },
  options: Parameters<typeof useUserWithPurchasedCoursesByIds>[1] = {},
) => {
  const {
    currentUser,
    loading: loadingCurrentUser,
    errors: currentUserErrors,
    ...rest
  } = useUserWithPurchasedCoursesByIds([course.id], options);

  const { tier: accessTier, loading: loadingAccess, error: accessError } = useAccessTier();

  const courseAccess = getUserCourseAccess(currentUser, course, accessTier);

  const loading = loadingCurrentUser || loadingAccess;
  const errors = compact([currentUserErrors, accessError]);

  return { loading, courseAccess, errors, ...rest };
};
